import axios from '@/resources/libs/axios'
import {GEI_AUXILIAR_PROVIDERS_LIST} from "@/router/web/constants"

export default {
    list(data) {
        return axios.get(`/gei/auxiliaries/providers/list/all`,{ params: data })
    },
    search(data) {
        return axios.get(`/gei/auxiliaries/providers/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/gei/auxiliaries/providers/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/gei/auxiliaries/providers/create`,  data)
    },
    update(data) {
        return axios.post(`/gei/auxiliaries/providers/update`,  data)
    },
    delete(id) {
        return axios.delete(`/gei/auxiliaries/providers/delete/${id}`)
    },
    listContactsProviders(id, data) {
        return axios.get(`/gei/auxiliaries/providers/contacts/list/${id}`, { params: data })
    },
    createContact(data){
        return axios.post(`/gei/auxiliaries/providers/contacts/create`,  data)
    },
    updateContact(data){
        return axios.post(`/gei/auxiliaries/providers/contacts/update`,  data)
    },
    deleteContact(id) {
        return axios.delete(`/gei/auxiliaries/providers/contacts/delete/${id}`)
    },
}
